import React from 'react'
import Navbar from '../components/Navbar'
import { Outlet } from 'react-router'
import Footer from '../components/Footer'

function PublicLayout() {
  return (
    <div className='bg-primario'>
        <Navbar/>
        <Outlet/>
        <Footer/>
    </div>
  )
}

export default PublicLayout